import { Col, Row } from 'antd';
import ErrorHandler from 'common/error/components/error-handler';
import OnWindowResize from 'common/placement/on-window-resize';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import { withRouter } from 'utils/withRouter';
import FiltersSidepanel from '../../common/filters/filters-sidepanel';
import { additionalTabTypes } from '../../utils/app-configs';
import WorkGridWrapper from '../../workgrid/components/work-grid-wrapper';
import CreateView from '../containers/create-view-container';
import ManageViews from '../containers/manage-views-container';
import { resetError } from '../containers/worklist-actions';
import WorklistWrapper from './worklist-wrapper';

const Wrapper = styled.div`
  margin: 15px;
`;

const AgWrapper = styled.div`
  width: calc(100% + 35px);
`;

const Worklist = ({
  isDataLoading,
  filterDefinitions,
  updateFilters,
  activeFilters,
  menuVisible,
  match,
  views,
  updateView,
  clearWorklistData,
  relativeTimingRangeOptions,
  error,
}) => {
  const filterRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => () => {
    dispatch(resetError());
  }, []);

  const handleRowClick = (item) => {
    if (item.uri) {
      window.open(
        `${window.location.origin}/${item.uri}/dashboard`, '_blank',
      );
    }
  };

  return <>
    <ErrorHandler type='notification' error={error} />
    <WorklistWrapper>
      <Wrapper>
        <OnWindowResize>
          {() =>
            <>
              <Row>
                <Col span={24}>
                  <AgWrapper>
                    <WorkGridWrapper
                      menuVisible={menuVisible}
                      filterWidth={filterRef?.current?.clientWidth}
                      handleOrderClick={handleRowClick}
                      clearWorklistData={clearWorklistData}
                      selectable={true}
                      hasIconsColumn={true}
                      sizeToFit={true}
                      worklistId={match.params.worklistId}
                      columnActions={{
                        Description: handleRowClick,
                      }}
                    />
                  </AgWrapper>
                </Col>
              </Row>
            </>
          }
        </OnWindowResize>
      </Wrapper>
      <Routes>
        <Route
          path={'filterselect'}
          element={<FiltersSidepanel
            filters={match.params.filters || ''}
            sort={match.params.sort || ''}
            worklistId={match.params.worklistId}
            filterRef={filterRef}
            isDataLoading={isDataLoading}
            filterDefinitions={filterDefinitions}
            updateFilters={updateFilters}
            activeFilters={activeFilters}
            isPlanningBoard={false}
            relativeTimingRangeOptions={relativeTimingRangeOptions}
            additionalTabs={[additionalTabTypes.columns]}
          />
          }
        />
        <Route
          path={'create-view'}
          element={<CreateView
            id={match.params.worklistId}
            filters={match.params.filters || ''}
            sort={match.params.sort || ''}
            updateView={updateView}
            views={views}
            expandOption={false}
          />
          }
        />
        <Route
          path={'manage-views'}
          element={<ManageViews id={match.params.worklistId} expandOption={false} />}
        />
      </Routes>
      <Outlet />
    </WorklistWrapper>
  </>;
};

Worklist.propTypes = {
  match: PropTypes.object.isRequired,
  isDataLoading: PropTypes.bool,
  updateFilters: PropTypes.func,
  updateView: PropTypes.func,
  activeFilters: PropTypes.object,
  filterDefinitions: PropTypes.array,
  menuVisible: PropTypes.bool,
  views: PropTypes.array,
  clearWorklistData: PropTypes.func,
  relativeTimingRangeOptions: PropTypes.object,
  error: PropTypes.object,
};

export default withRouter(Worklist);
